import React from "react";

const ProductsIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M17 28.7299C17.304 28.9054 17.6489 28.9979 18 28.9979C18.3511 28.9979 18.696 28.9054 19 28.7299L26 24.7299C26.3037 24.5545 26.556 24.3024 26.7315 23.9987C26.9071 23.6951 26.9996 23.3506 27 22.9999V14.9999C26.9996 14.6492 26.9071 14.3047 26.7315 14.0011C26.556 13.6974 26.3037 13.4453 26 13.2699L19 9.2699C18.696 9.09437 18.3511 9.00195 18 9.00195C17.6489 9.00195 17.304 9.09437 17 9.2699L10 13.2699C9.69626 13.4453 9.44398 13.6974 9.26846 14.0011C9.09294 14.3047 9.00036 14.6492 9 14.9999V22.9999C9.00036 23.3506 9.09294 23.6951 9.26846 23.9987C9.44398 24.3024 9.69626 24.5545 10 24.7299L17 28.7299Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M18 29V19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M9.29004 14L18 19L26.71 14"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M13.5 11.2695L22.5 16.4195"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ProductsIcon;
